import { render, staticRenderFns } from "./OwnerNotification.vue?vue&type=template&id=76e6f7e7&scoped=true&"
import script from "./OwnerNotification.vue?vue&type=script&lang=js&"
export * from "./OwnerNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e6f7e7",
  null
  
)

export default component.exports